<script>

import Layout from '@layouts/primary'
import { RRule } from 'rrule'
import { clientMethods } from '@state/helpers'

export default {
  $_veeValidate: {
    validator: 'new',
  },
  page: {
    title: 'ClientReports',
    meta: [{ name: 'description', content: 'ClientReports' }],
  },
  components: { Layout },
  data() {
    return {
      search: '',
      headers: [
        { text: 'Company', value: 'client_name' },
        { text: 'Contact Name', value: 'contact_name' },
        { text: 'Mobile', value: 'mobile' },
        { text: 'Email', value: 'email' },
        { text: 'Actions', value: 'name', sortable: false },
      ],

      binHeaders: [
        { text: 'Id', value: 'id' },
        { text: 'Type', value: 'bin.description' },
        { text: 'Capacity', value: 'bin.capacity' },
        { text: 'Price', value: 'price' },
        { text: 'Extra Price', value: 'extra_price' },
        { text: 'Maintenance Fee', value: 'weekly_maintenance_fee' },
      ],
      clients: [],
      services: [],
      clientId:'',
      dialog: true,
      isSameAddress: false,
      messagePopUp: false,
      dictionary: {
        attributes: {
          email: 'E-mail Address',
          // custom attributes
        },
        custom: {
          name: {
            required: () => 'Name can not be empty',
            max: 'The name field may not be greater than 10 characters',
            // custom messages
          },
          select: {
            required: 'Select field is required',
          },
        },
      },
      addClient: false,
      requestView:false,
      error: {
        uniqueClientName: null,
        uniqueEmail: null
      }
    }
  },
  mounted() {
    this.$validator.localize('en', this.dictionary)
    this.getClientsWithSitesAndServices().then(response => {
      let obj = response
      let objClients = {
        ...obj
      }
      let formattedClients = []
      for (let client in objClients) {
        if(objClients && objClients[client] && objClients[client].service_agreements){
          let agree = objClients[client].service_agreements
          // console.log('agree',agree)
          for (var v in agree) {
            let formattedObj = {
              ...agree[v]
            }
            // store each agreement id as an int
            formattedObj.id=parseInt(formattedObj.id)
            // get the location details for each agreement
            // this.serviceAgreements.push(formattedObj)
            // console.log(this.serviceAgreements)

            let services = []
            // get only active services
            for(let i in formattedObj.services){
              if(formattedObj.services[i].active){
                services.push(formattedObj.services[i])
              }
            }
            // let services = formattedObj.services
            for (var i in services){
              if(services[i].active === true){
                // display schedule based on RRule
                if(services[i].schedule_string !== 'ON CALL'){
                  // Remove COUNT=5 from the string - REMOVED IT AS IT WASN'T DOING THE CONVERSION RIGHT
                  // let schedule = services[i].schedule_string.split(';');
                  // let rule = RRule.fromString(schedule[0]);
                  let schedule = ''
                  let rule = RRule.fromString(services[i].schedule_string);
                  schedule= rule.toText();

                  services[i].schedule=schedule
                } else {
                  services[i].schedule = 'On Call';
                }

                // get the total maintenance and service fees from each service bin in each service
                var maintenanceSum = 0
                var serviceSum = 0
                var capacitySum = 0
                var bins = services[i].service_bins
                for (var b in bins){
                  if(bins[b].weekly_maintenance_fee) {
                    maintenanceSum = maintenanceSum + bins[b].weekly_maintenance_fee
                  }
                  // check if there is a custom price for the service bin
                  // if not - use the default bin price
                  if (bins[b].price){
                    serviceSum = serviceSum + bins[b].price
                  }
                  else {
                    serviceSum = serviceSum + bins[b].bin.price
                  }
                  capacitySum = capacitySum + bins[b].bin.capacity
                }
                services[i].serviceSum=serviceSum
                services[i].maintenanceSum=maintenanceSum
                services[i].capacitySum=capacitySum
              }
            }
            this.services = services
            formattedObj.services_new = services
            objClients[client].service_agreements_new = formattedObj
          }
          formattedClients.push(objClients[client])
        }
      }
      this.clients = formattedClients

      // order by name
      this.clients.sort(this.compare);

      // hide loader
      this.dialog = false
      // eslint-disable-next-line handle-callback-err
    }).catch(error => {
      this.dialog=false
    })
  },
  methods: {
    ...clientMethods,
    changeRoute(r) {
      this.$router.push(r)
    },
    compare(a, b) {
      const clientA = a.client_name.toUpperCase();
      const clientB = b.client_name.toUpperCase();

      let comparison = 0;
      if (clientA > clientB) {
        comparison = 1;
      } else if (clientA < clientB) {
        comparison = -1;
      }
      return comparison;
    },
    getMaintenanceFee(fee){
      // console.log('FEE: ' + fee);
      if (fee !== null){
        return fee / 100;
      } else {
        return 0;
      }
    },
    Daily() {
      // console.log(RRule.DAILY)
      return RRule.DAILY
    },
    Weekly() {
      // console.log(RRule.WEEKLY)
      return RRule.WEEKLY
    },
    Monthly() {
      // console.log(RRule.MONTHLY)
      return RRule.MONTHLY
    },
    Yearly() {
      // console.log(RRule.YEARLY)
      return RRule.YEARLY
    },
  },
}
</script>

<template>
  <Layout>
    <VContainer>
      <h2 :class="$style.routeHeader">
        All Clients Reports
      </h2>
      <div slot="header">
        <div v-if="clients">
          <VCard
            v-for="client in clients"
            :key="client.id"
            class="v-card-padding agreement-card client-card"
          >
            <h3
              :class="$style.routeHeader"
              style="margin-bottom: 20px"
            >
              Client: {{ client && client.client_name ? client.client_name : '' }}
            </h3>
            <div
              v-if="client && client.service_agreements_new"
            >
              <div v-if="client.service_agreements_new">
                <div
                  v-if="client.service_agreements_new.services_new"
                >
                  <div
                    v-for="agreement in client.service_agreements_new.services_new"
                    :key="agreement.id"
                    :class="$style.cardWrapper"
                  >
                    <div
                      class="v-card-padding agreement-card "
                      style="padding-bottom: 0 !important"
                    >
                      <h4
                        v-if="agreement && agreement.site"
                        class="fixedSpaceVertical"
                      >
                        Trading: {{ agreement.site.trading_name }}
                      </h4>
                      <p
                        v-if="agreement.site"
                      >
                        <strong class="strongReport">
                          Site:
                        </strong> {{ agreement.site.address }}, {{ agreement.site.suburb }} {{ agreement.site.postcode }}
                      </p>
                      <p v-if="agreement.service_title">
                        <strong class="strongReport">
                          Service:
                        </strong> {{ agreement.service_title }}
                      </p>
                      <p v-if="agreement.description">
                        {{ agreement.description }}
                      </p>
                      <p v-if="agreement.waste_type">
                        <strong class="strongReport">
                          Waste Type:
                        </strong>{{ agreement.waste_type.name }}
                      </p>
                      <p v-if="agreement.schedule">
                        <strong class="strongReport">
                          Schedule:
                        </strong>{{ agreement.schedule }}
                      </p>

                      <VSpacer />
                      <VSpacer />
                      <p v-if="agreement.service_bins">
                        <strong class="strongReport">
                          Bins
                        </strong>
                      </p>
                      <VDataTable
                        v-if="agreement.service_bins"
                        :headers="binHeaders"
                        :items="agreement.service_bins"
                        rows-per-page-text=""
                        :rows-per-page-items="[9999999999]"
                      >
                        <template
                          slot="items"
                          slot-scope="props"
                        >
                          <td class="text-xs-left">
                            {{ props.item.id }}
                          </td>
                          <td class="text-xs-left">
                            {{ props.item.bin.description }}
                          </td>
                          <td class="text-xs-left">
                            {{ props.item.bin.capacity }}
                          </td>
                          <td
                            v-if="props.item.price"
                            class="text-xs-left"
                          >
                            $ {{ props.item.price > 0 ? props.item.price / 100 : props.item.price }}
                          </td>
                          <td
                            v-if="props.item.extra_price"
                            class="text-xs-left"
                          >
                            $ {{ props.item.extra_price > 0 ? props.item.extra_price / 100 : props.item.extra_price }}
                          </td>
                          <td
                            v-if="!props.item.extra_price || props.item.extra_price === 0"
                            class="text-xs-left"
                          >
                            $ 0
                          </td>
                          <td
                            v-if="!props.item.price"
                            class="text-xs-left"
                          >
                            $ 0
                          </td>
                          <td
                            class="text-xs-left"
                          >
                            $ {{ getMaintenanceFee(props.item.weekly_maintenance_fee) }}
                          </td>
                        </template>
                      </VDataTable>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </VCard>
        </div>
      </div>
    </VContainer>
    <VDialog
      v-model="dialog"
      hide-overlay
      persistent
      width="300"
    >
      <VCard
        color="primary"
        dark
      >
        <VCardText>
          Loading..
          <VProgressLinear
            indeterminate
            color="white"
            class="mb-0"
          />
        </VCardText>
      </VCard>
    </VDialog>
  </Layout>
</template>

<style lang="scss" module>
  @import '@design';

  .routeHeader {
    display: inline-block;
  }

  .cardWrapper{
    border: 1px solid #f2f2f2;
    margin-bottom: 10px;
  }

  .iconSpace{
    margin-right: 4px;
  }

  .addButton {
    display: inline-block;
    float: right;
  }

  .error{
    width: 100%;
    padding:25px 25px 0 25px;
    color: red;
    text-align: center;
  }

</style>
